// eslint-disable-next-line no-restricted-imports
import queryString from 'query-string'

import { buildLink } from '@masterplandev/utils'

const base = '/learnpaths'

type AssignedListOptions = {
  categoryId?: string
  isCourse?: boolean
  learnpathId?: string
}

function assigned({
  categoryId,
  isCourse,
  learnpathId,
}: AssignedListOptions = {}) {
  const url = buildLink(base, 'assigned', learnpathId)

  // Only the list endpoint supports list query params.
  if (learnpathId) return url

  const query = queryString.stringify({
    is_course: isCourse ? 'true' : undefined,
    categories: categoryId,
  })
  return `${url}${query ? `?${query}` : ''}`
}

function assignedElement(learnpathId: string, elementId?: string) {
  return buildLink(assigned(), learnpathId, 'elements', elementId)
}

function assignedQuizAnswerCheck(learnpathId, quizId, questionId) {
  return buildLink(
    assignedElement(learnpathId),
    'quiz',
    quizId,
    'check_question',
    questionId,
  )
}

function assignedElementProgress(learnpathId, elementId) {
  return buildLink(assignedElement(learnpathId, elementId), 'progress')
}

function assignedConfirmCompletion(learnpathId) {
  return buildLink(assigned({ learnpathId }), 'confirm-completion')
}

function join(sharingLinkId) {
  return buildLink(base, 'join', sharingLinkId)
}

export default {
  assigned,
  assignedConfirmCompletion,
  assignedElement,
  assignedElementProgress,
  assignedQuizAnswerCheck,
  join,
}
